import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import {Input} from 'antd';

import "./Summary.css";
import Intervention from "../../services/Intervention";
import InterventionStatus from "../common/format/InterventionStatus";
import InterventionType from "../intervention/InterventionType";
import BoldText from "../common/text/BoldText";
import DateFormat from "../common/format/DateFormat";
import Constants from "../../services/Constants";
import LeasebaseContract from "./contracts/LeasebaseContract";
import SAInput from "../common/input/SAInput";
import SAInputDistance from "../common/input/SAInputDistance";
import {withRouter} from "react-router-dom";
import Address from "../common/Address";

const { TextArea } = Input;

class Summary extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.intervention && nextProps.intervention.vehicle) {
      this.setState({vehicle: nextProps.intervention.vehicle})
    }
    const {fetchInterventionComment} = nextProps;
    if (fetchInterventionComment && fetchInterventionComment.interventionComment) {
      this.setState({comment: fetchInterventionComment.interventionComment.comment})
    }
  }

  componentDidMount() {
    const {intervention: {id, vehicle: {vin}}} = this.props;
    this.props.dispatchFetchInterventionComment(id);
    this.props.dispatchFetchVehicleContracts(vin, id);
  }

  handleSaveComment = () => {
    const {intervention:{id}} = this.props;
    this.props.dispatchSaveInterventionComment(id, {comment:this.state.comment});
  };

  handleSaveVehicleInfo = () => {
    const {vehicle: {mileage, licensePlate}} = this.state;
    const {intervention:{id}} = this.props;
    this.props.dispatchUpdateJourneyVehicle(id, {mileage, licensePlate});
  };

  onCommentChange = (e) => {
    this.setState({
      comment: e.target.value
    });
  };

  onMileageChange = (value) => {
    const {vehicle} = this.state;
    vehicle.mileage = value;
    this.setState({vehicle});
  };

  onLicensePlateChange = (e) => {
    const {vehicle} = this.state;
    vehicle.licensePlate = e.target.value;
    this.setState({vehicle});
  };

  renderContracts = (intervention) => {
    const {contracts = []} = intervention;

    return contracts.map((contract, id) => {
      return (
          <LeasebaseContract key={id} contract={contract}/>
      )
    })
  };

  render() {
    const {intl:{formatMessage}, intervention, updateJourneyVehicle: {error = {}}, fleetbackInterventions} = this.props;
    const {vehicle} = this.state;

    if (!intervention) {
      return null;
    }

    const errors = error.content || {};
    return (
      <div>
        <section className="main-aside-block">
          <div className="main-aside-block__body">
            <div className="d-flex justify-content-between align-items-center">
              <span className="badge-status">
                <InterventionStatus status={intervention.status} previousStatus={intervention.prevStatus}/>
              </span>
              <div>
                {intervention.journey && intervention.journey.properties && <InterventionType journey={{properties: intervention.journey.properties}} fleetback={fleetbackInterventions && fleetbackInterventions.length > 0}/>}
              </div>
            </div>

            <ul className="list-bordered list-bordered--top list-bordered--no-bottom list--array">
              {intervention.status === Constants.STATUS_ARCHIVED.value &&
                <li>
                <span className="list__key">{formatMessage({id:'summary.archived-on'})}:</span>
                <span className="list__value"><DateFormat className="ml-1" layout="dateTimeLong" date={intervention.archivedOn}/></span>
              </li>
              }
              <li>
                <span className="list__key">{formatMessage({id:'summary.service-advisor'})}:</span>
                <span className="list__value">{intervention.advisor}</span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.appointment.origin'})}:</span>
                <span className="list__value">{formatMessage({id: `summary.appointment.origin.${Intervention.getDisplayOrigin(intervention.origin, intervention.vehicle.brand)}`})}</span>
              </li>
            </ul>

            <div className="txtright">
              <button className="btn btn-sm btn-o-secondary" onClick={() => {this.props.history.push({pathname: `/interventions`, search: `search=${intervention.vehicle.vin}`})}}>
                {formatMessage({id: 'summary.appointment.history'})}
              </button>
            </div>
          </div>
        </section>

        <section className="main-aside-block">
          <header className="main-aside-block__header">
            <h2 className="main-aside-block__title">{formatMessage({id:'summary.customer-car'})}</h2>
          </header>
          <div className="main-aside-block__body">
            <ul className="list-bordered list--array">
              <li>
                <span className="list__key">{formatMessage({id:'summary.customer'})}:</span>
                <span className="list__value">
                  {
                    intervention.customer && `${intervention.customer.firstName} ${intervention.customer.lastName}`
                  }
                  {
                    intervention.customer && intervention.customer.customerAddress &&
                    <Address address={{...intervention.customer.customerAddress}}/>
                  }
                  </span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.phone'})}</span>
                <span className="list__value">{intervention.phone || (intervention.customer && intervention.customer.phone)}</span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id: 'cui.home.login.username'})}</span>
                <span className="list__value">{intervention.customer && !intervention.customer.login.startsWith('DUMMY') &&
                  <a href={`mailto:${intervention.customer.login}`}>{intervention.customer.login}</a>}</span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.car'})}:</span>
                <span className="list__value">{vehicle && `${vehicle.brand} ${vehicle.model}`}</span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.vin'})}:</span>
                <span className="list__value">{vehicle && <BoldText text={vehicle.vin} boldEndCharacters={7}/>}</span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.mileage'})}:</span>
                <span className="list__value"><SAInputDistance value={vehicle && vehicle.mileage} onChange={this.onMileageChange} error={errors.mileage} disabled={!intervention.journey}/></span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.license-plate'})}:</span>
                <span className="list__value">
                  <SAInput value={vehicle && vehicle.licensePlate} onChange={this.onLicensePlateChange} error={errors.licensePlate} maxLength={50} disabled={!intervention.journey} className='right uppercase'/>
                </span>
              </li>
              <li>
                <span className="list__key">{formatMessage({id:'summary.leasing-company'})}:</span>
                <span className="list__value">{intervention.leasingCompany}</span>
              </li>
            </ul>
            {intervention.journey &&
              <p className="txtright" style={{marginTop: '2rem'}}>
                <button onClick={this.handleSaveVehicleInfo} className="btn btn-sm btn-o-secondary">{formatMessage({id: 'action.save'})}</button>
              </p>
            }
          </div>
        </section>

        <section className="main-aside-block">
          <header className="main-aside-block__header">
            <h2 className="main-aside-block__title">{formatMessage({id:'summary.contracts'})}</h2>
          </header>
          <div className="main-aside-block__body">
              {this.renderContracts(intervention)}
          </div>
        </section>

        <section className="main-aside-block">
          <header className="main-aside-block__header">
            <h2 className="main-aside-block__title">{formatMessage({id:'summary.comment'})}</h2>
          </header>
          <div className="main-aside-block__body">
            <div className="advisor-comment">
              <TextArea name="advisor-comment" autosize={true} onChange={this.onCommentChange} className="advisor-comment__field" value={this.state.comment}/>
            </div>
            <br/>
            <p className="txtright">
              <button onClick={this.handleSaveComment} className="btn btn-sm btn-o-secondary">{formatMessage({id:'action.save'})}</button>
            </p>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInterventionComment: state.fetchInterventionComment,
  saveInterventionComment: state.saveInterventionComment,
  updateJourneyVehicle: state.updateJourneyVehicle,
  fleetbackInterventions: state.fleetbackInterventions && state.fleetbackInterventions.payload
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchInterventionComment: (id) => dispatch({type: 'FETCH_INTERVENTION_COMMENT.REQUEST', id}),
  dispatchSaveInterventionComment: (id, body) => dispatch({type: 'SAVE_INTERVENTION_COMMENT.REQUEST', id, body}),
  dispatchFetchVehicleContracts: (vin, interventionId) => dispatch({type: 'FETCH_VEHICLE_CONTRACTS.REQUEST', vin, interventionId}),
  dispatchUpdateJourneyVehicle: (id, body) => dispatch({type: 'UPDATE_JOURNEY_VEHICLE.REQUEST', id, body}),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Summary)));



// WEBPACK FOOTER //
// ./src/components/interventiondetail/Summary.js